type SpritePreloadLinkProps = {
  sprite: string;
};

export function SpritePreloadLink({ sprite }: SpritePreloadLinkProps) {
  return <link href={sprite} rel="preload" as="image" type="image/svg+xml" />;
}
